export const topbarMenuConfig = (baseUrl: string, employerUrl: string) => [
  {
    label: 'Acasă',
    url: baseUrl,
  },
  {
    label: 'Soluții',
    items: [
      {
        label: 'Sunt Angajat',
        url: `${baseUrl}/angajat/`,
      },
      {
        label: 'Sunt Angajator',
        url: `${baseUrl}/angajator/`,
      },
      {
        label: 'Cum ne comparăm cu alții',
        url: `${baseUrl}/cum-ne-comparam-cu-altii/`,
      },
    ],
  },
  {
    label: 'Despre Noi',
    url: `${baseUrl}/despre-noi/`,
  },
  {
    label: 'Pensia Facultativă',
    items: [
      {
        label: 'Cine sunt persoanele eligibile?',
        url: `${baseUrl}/cine-sunt-persoanele-eligibile/`,
      },
      {
        label: 'Beneficiile pensiilor facultative',
        url: `${baseUrl}/beneficiile-pensiilor-facultative/`,
      },
      {
        label: 'Fondurile de pensii facultative',
        url: `${baseUrl}/fondurile-de-pensii-facultative/`,
      },
    ],
  },
  {
    label: 'Resurse',
    items: [
      {
        label: 'Articole',
        url: `${baseUrl}/blog/`,
      },
      {
        label: 'Ghiduri de pensii facultative',
        url: `${baseUrl}/ghiduri-de-pensii-facultative/`,
      },
      {
        label: 'Ghid de plată al contribuțiilor',
        url: `${baseUrl}/ghid-de-plata-a-contributiilor/`,
      },
      {
        label: 'Documente',
        url: `${baseUrl}/documente/`,
      },
    ],
  },
  {
    label: 'Contact',
    url: `${baseUrl}/contact/`,
  },
  {
    label: 'Conectare angajator',
    url: `${employerUrl}`,
    style: {
      display: 'flex',
      'background-color': '#E91E98',
      'justify-self': 'end',
      'border-radius': '5px',
      'margin-left': '3px',
    },
  },
];
